import MovieCard from './MovieCard'

export default function MovieRow({ title, movies, href, seeAll = true, variant = 'poster' }) {
  if (!movies || movies.length === 0) return null

  return (
    <section className="animate-fade-in" style={{ animationDelay: '0.1s' }}>
      <div className="flex items-center justify-between mb-4 px-4">
        <h2 className="text-xl font-bold tracking-tight">{title}</h2>
        {seeAll && href && (
          <a href={href} className="text-sm text-primary-500 hover:text-primary-400 font-medium transition-colors flex items-center gap-1">
            Lihat Semua
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
          </a>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 px-4 pb-8">
        {movies.slice(0, variant === 'list' ? 10 : 12).map((movie, idx) => (
          <MovieCard key={movie.id} movie={movie} variant={variant} style={{ animationDelay: `${idx * 0.05}s` }} />
        ))}
      </div>
    </section>
  )
}
